import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserSessionService } from '../../app-user-session.service';
import { SelectizeModule } from '../../blocks';
import { BlocksModule } from '../../blocks/blocks.module';
import { ObjListFilterPipeModule } from '../../blocks/pipes/obj-list-filter.pipe';
import { docuMangeNewgModule } from '../../docu-manage-new/docu-manage-new.module';
import { NgbDatepickerModule } from '../../ng-bootstrap';
import { ControlsParams, OutpatientParms, SharedDateService, AppCodeGroup, SharedModule } from '../../shared';
import { SalesOrderHistoryPopUpService } from './sales-order-history-popup.service';


@Component({
  selector: 'sales-order-history-popup.component',
  templateUrl: './sales-order-history-popup.component.html',
})

export class SalesOrderHistoryPopUpComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  controlsParams: ControlsParams;
  outPatientObj: OutpatientParms = <OutpatientParms>{};
  salesOrderList = []
  totalValue: any = {};
  salesOrderDetail = []

  constructor(
    public translate: TranslateService,
    private _userSessionService: UserSessionService,
    private _sharedDateService: SharedDateService,
    private _SalesOrderHistoryPopUpService: SalesOrderHistoryPopUpService

  ) {
    this.controlsParams = new ControlsParams(77, AppCodeGroup.Buttons, true);
  }

  ngOnInit() {
    this._userSessionService.subscribeToKey$('OpenSalesOrderHistory').pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          console.log(keys.value)
          this.outPatientObj.patCode = keys.value.code
          this.outPatientObj.tServiceId = keys.value.serviceId
          this.getOpenSalesOrderHistory()
        }
      })

    this._userSessionService.subscribeToKey$('resetSalesOrderHistory').pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          console.log('resetSalesOrderHistory')
          this.salesOrderList = [];
          this.salesOrderDetail = []
        }
      })

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  getOpenSalesOrderHistory() {
    this.salesOrderList = [];
    this.totalValue = {};
    this._SalesOrderHistoryPopUpService.getSalesOrderList(this.outPatientObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data && res.data.length > 0) {
            this.salesOrderList = res.data
            console.log('this.salesOrderList', this.salesOrderList)
          }
          if (res && res.data1 && res.data1.length > 0) {
            this.totalValue = res.data1[0];
          }
        },
        error => console.log(error),
        () => {
        });
  }
  save() {

  };


  showDetail: boolean
  getSalesOrderDetail(row) {
    this.salesOrderDetail = []
    this.showDetail = true;
    this.outPatientObj.billPatSerial = row.serial
    this.outPatientObj.regPatServiceSerial = row.regPatServiceSerial
    this._SalesOrderHistoryPopUpService.getSalesOrderDetail(this.outPatientObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data && res.data.length > 0) {
            this.salesOrderDetail = res.data
            console.log('this.salesOrderDetail', this.salesOrderDetail)
          }
        },
        error => console.log(error),
        () => {
        });
  }

}

@NgModule({
    imports: [
        SharedModule,
        //    BlocksModule,
        //   docuMangeNewgModule,
        //   SelectizeModule,
        //   CommonModule,
        //   FormsModule,
        //   ReactiveFormsModule,
        //   ObjListFilterPipeModule,
        //   NgbDatepickerModule,
        //   TranslateModule.forChild()
    ],
    declarations: [SalesOrderHistoryPopUpComponent],
    providers: [SalesOrderHistoryPopUpService],
    exports: [SalesOrderHistoryPopUpComponent]
})
export class SalesOrderHistoryModule { }



